import request from '@/router/axios'

/**
 * 获取安全检查汇总报告数据（合并返回：检查项数量、隐患统计、事故统计）
 * @param {Object} params - 查询参数
 * @param {String} params.month - 月份，格式：2023-05
 * @param {String} params.reportScope - 报告范围：全部部门/选择部门
 * @param {Array<String>} params.deptIds - 部门ID列表（可选，当reportScope为"选择部门"时必填）
 * @returns {Promise} 返回KPI指标数据（检查项数量、隐患数量、已完成整改数量、整改完成率、事故数量）
 */
export const getSafetyReportSummary = (params) => {
  return request({
    url: '/api/produce/safety-report/summary',
    method: 'post',
    data: params
  })
}

/**
 * 获取部门统计（柱形图数据）
 * @param {Object} params - 查询参数
 * @param {String} params.month - 月份，格式：2023-05
 * @param {String} params.reportScope - 报告范围：全部部门/选择部门
 * @param {Array<String>} params.deptIds - 部门ID列表（可选，当reportScope为"选择部门"时必填）
 * @returns {Promise} 返回部门统计列表
 */
export const getDeptStats = (params) => {
  return request({
    url: '/api/produce/safety-report/overview/dept',
    method: 'post',
    data: params
  })
}

/**
 * 获取检查类型统计（环形图数据）
 * @param {Object} params - 查询参数
 * @param {String} params.month - 月份，格式：2023-05
 * @param {String} params.reportScope - 报告范围：全部部门/选择部门
 * @param {Array<String>} params.deptIds - 部门ID列表（可选，当reportScope为"选择部门"时必填）
 * @returns {Promise} 返回检查类型统计列表
 */
export const getTypeStats = (params) => {
  return request({
    url: '/api/produce/safety-report/overview/type',
    method: 'post',
    data: params
  })
}


// 获取部门树形数据
export const getDeptTree = () => {
  return request({
    url: "/api/produce/blade-dept/select/deptSelect",
    method: "get",
  });
};

